import { render } from "./RecentProjects2.vue?vue&type=template&id=43afb9c2&scoped=true"
import script from "./RecentProjects2.vue?vue&type=script&lang=js"
export * from "./RecentProjects2.vue?vue&type=script&lang=js"

import "./RecentProjects2.vue?vue&type=style&index=0&id=43afb9c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43afb9c2"

export default script